<template>
    <div class="teaching p_t">
        <TopHead title="教学展示"></TopHead>
        <van-pull-refresh v-model="loading" @refresh="onRefresh">
          <van-list
            :immediate-check="false"
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad">
              <ul class="list">
                <li v-for="item in list" :key="item.commodityId" @click="detail(item.contentId)">
                  <img :src="item.coverUrl" alt="">
                  <div>
                      <h6>{{item.title}}</h6>
                      <p>{{item.synopsis}}</p>
                  </div>
                </li>
              </ul>
          </van-list>
        </van-pull-refresh>
    </div>
</template>
<script>
export default {
    data(){
        return{
          refreshing:false,
          loading:true,
          finished:false,
          list:[],
          params:{
            columnCode: "jxzs",
            pageIndex:1,
            pageSize:6,

          },
        }
    },
    created() {
      this.getTeachingList()
    },

    methods: {
        detail(item) {
            this.$router.push(`/TeachingDetail?contentId=${item}`)
        },
        // 得到列表
        getTeachingList(){
          this.loading = true;
        this.$api.listContent(this.params).then(res => {
          console.log(res);

          this.loading = false;
          if (this.refreshing) {
            this.refreshing = false;
          }
          if(res.data.recordCount){
            this.list = this.list.concat(JSON.parse(JSON.stringify(res.data.rows)));
          }
          let list = res.data.rows;
          if (!list || list.length < this.params.pageSize) {
            this.finished = true;
          }
        })
        },
        onRefresh(){
          this.list = [];
          this.finished = false;
          this.params.pageIndex = 1;
          this.getTeachingList();
        },
      onLoad(){
        let me = this;
        if(me.loading) return
        let page = me.params.pageIndex;
        page = page ? page + 1 : 1;
        this.params.pageIndex = page;
        this.getTeachingList();
      },
    },
}
</script>
<style lang="scss" scoped>
.teaching{
    background: #f0f0f0;
}
.list {
   padding:0 13px 15px;
   margin-top: 14px;
}
.list li{

    margin-bottom: 8px;
    background: #fff;
    height: 100px;
    padding: 10px;
    border-radius: 10px;
    display: flex;

    img{
      width: 160px;
      height: 100px;
    }
    >div{
      width: 155px;
      margin-left: 13px;
      padding-top: 8px;
      h6{
        font-size: 14px;
      }
      p{
        margin-top: 17px;
        color: #9d9d9d;
        font-size: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }
  .title{
    display: flex;
    margin-bottom: 10px;
    h4{
      font-size: 17px;
    }
    span{
      display: block;
      margin-left: auto;
      color:#6b6b6b;
      font-size: 14px;
    }
  }
</style>
